<template>
  <v-container
    fluid
    grid-list-md
  >
    <h1 class="text-h5 mb-6">{{ $t('Inventory Counts') }}</h1>
    <inventory-counts-table include-search />
  </v-container>
</template>

<script>
import Vue from 'vue'
import InventoryCountsTable from '@/components/inventory-counts/InventoryCountsTable'

export default {
  metaInfo () {
    return { title: this.pageTitle }
  },

  components: {
    InventoryCountsTable
  },

  data: () => ({
    pageTitle: Vue.i18n.translate('Inventory Counts')
  })
}
</script>



// WEBPACK FOOTER //
// src/views/inventory-counts/Index.vue